import { ErrorCode, OverduePaymentResponse, OrderResponse } from '@afterpaytouch/portal-api/types'
import { isOverduePaymentEligibleErrorCode, RecoverableTerminalErrorsNotification } from '../../model'
import { useGetPayableOrderTransactionsQuery, useCheckoutToken, useIsRecoverableFlow, useGetOverduePaymentsQuery, usePreferredCard } from '../../state'

interface QueryStates {
  isLoading: boolean
  isFetching: boolean
  isSuccess: boolean
  isError: boolean
}

type OverduePaymentQueryResponse = QueryStates & {
  isOverdue: true
  data?: OverduePaymentResponse
}

type PayableOrderTransactionQueryResponse = QueryStates & {
  isOverdue: false
  data?: OrderResponse[]
}

type UseConsolidatedQueryHook = OverduePaymentQueryResponse | PayableOrderTransactionQueryResponse

export const useConsolidatedQuery = (filterBy: ErrorCode): UseConsolidatedQueryHook => {
  const token = useCheckoutToken()
  const isRecoverableFlow = useIsRecoverableFlow()
  const isOverdue = isOverduePaymentEligibleErrorCode(filterBy)
  const overduePaymentsQuery = useGetOverduePaymentsQuery(undefined, { skip: !isRecoverableFlow || !isOverdue })
  const payableOrderTransactionQuery = useGetPayableOrderTransactionsQuery({ filterBy, token }, { skip: !isRecoverableFlow || isOverdue })

  if (isOverdue) {
    return {
      isOverdue,
      isLoading: overduePaymentsQuery.isLoading,
      data: overduePaymentsQuery.data,
      isFetching: overduePaymentsQuery.isFetching,
      isSuccess: overduePaymentsQuery.isSuccess,
      isError: overduePaymentsQuery.isError,
    }
  }

  return {
    isOverdue,
    isLoading: payableOrderTransactionQuery.isLoading,
    data: payableOrderTransactionQuery.data,
    isFetching: payableOrderTransactionQuery.isFetching,
    isSuccess: payableOrderTransactionQuery.isSuccess,
    isError: payableOrderTransactionQuery.isError,
  }
}

export const useShouldShowNotification = (notification: RecoverableTerminalErrorsNotification | null, clicked: boolean): boolean => {
  const { reason } = usePreferredCard() ?? {}

  if (reason === 'fallbackGenericMessage') {
    return false
  }
  return notification !== null && !clicked
}
